import { IAgentsAPIState } from "../types/agents.types";

export const AGENTS_INITIAL_STATE: IAgentsAPIState = {
  data: {
    list: [],
    totalPages: 0,
    totalRecords: 0,
  },
  superAgents: [],
  subAgents: [],
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  list: [],
  loading: false,
  error: null,
  currentScreen: "list",
  selectedAgent: null,
  agentType: "Master Agents",
  loginAgentInfo: null,
};
